import { useEffect, useState } from 'react';
import { Table } from 'components/common/Table/Table';
import { useTranslation } from 'react-i18next';
import { BREAK_INDEXES, fullTestData, sectionTestData, timeSection } from './StructureData';
import { getFullTestColumns, getSectionTestColumns } from './StructureColumns';
import { MOCK_TEST_TYPE } from '@app/constants/mockTest';

interface Column {
  title: string;
  dataIndex: string;
  key?: string;
  render?: (
    text: any,
    record: any,
    index: number,
  ) => JSX.Element | { children?: JSX.Element | null; props: { colSpan?: number; rowSpan?: number } };
  width?: string;
}

interface Data {
  key: number;
  part?: string;
  content?: string;
  time?: string;
}

interface IStructureProps {
  type: string;
  section: string;
}

export const Structure: React.FC<IStructureProps> = ({ type, section }) => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<Column[]>([]);
  const [data, setData] = useState<Data[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    initTestByType(type);
  }, [t, type]);

  const initTestByType = (type: string) => {
    if (type === MOCK_TEST_TYPE.FULL_TEST) {
      setColumns(getFullTestColumns(t));
      setData(fullTestData(t));
    } else if (type === MOCK_TEST_TYPE.SECTION_TEST) {
      const list = sectionTestData(t)[section] || [];
      const rowSpanCount = list.length;

      setColumns(getSectionTestColumns(t, rowSpanCount));

      const data = list.map((item, index) => ({
        key: index + 1,
        part: index === 0 ? `${t('page.mockTest.intro.part')} 1` : undefined,
        content: item.content,
        time: item.time,
      }));

      setData(data);
    }
  };

  return (
    <div className="flex flex-col rounded-lg bg-white p-8">
      <p className="font-semibold">
        {t('page.mockTest.intro.description')} {timeSection(type == MOCK_TEST_TYPE.FULL_TEST ? type : section, t)}
      </p>

      <Table
        className="mt-5"
        columns={columns}
        dataSource={data}
        loading={loading}
        scroll={{ x: 800 }}
        bordered
        pagination={false}
      />
    </div>
  );
};
